;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { clsx } from 'clsx/lite'
import type { ComponentProps } from 'react'

export function Heading({
  children,
  color = 'dark/light',
  className,
  ...props
}: { color?: 'dark/light' | 'light' } & ComponentProps<'h1'>) {
  return (
    <h1
      className={clsx(
        // From `lg` up — where the hero splits into text and visual — the size is fluid, so a
        // headline holds to two lines across that whole range rather than at one width only. It
        // stops growing at 54px, where the container stops growing too. Below `lg` the hero is a
        // single column and the headline wraps to as many lines as it needs.
        'font-display text-[2.75rem]/[1.07] tracking-[-0.04em] text-balance',
        'lg:text-[clamp(2.375rem,3.75vw,3.375rem)]',
        '[&_b]:font-[inherit] [&_b]:text-accent-deep [&_b]:dark:text-accent-bright',
        color === 'dark/light' && 'text-mist-950 dark:text-white',
        color === 'light' && 'text-white',
        className,
      )}
      {...props}
    >
      {children}
    </h1>
  )
}
